import { z } from 'zod';

import { apiClient } from './api-client';

const runSchema = z.object({
  id: z.string().uuid(),
  saasProductId: z.string().uuid(),
  status: z.enum(['queued', 'running', 'paused', 'completed', 'failed', 'cancelled']),
  isDryRun: z.boolean(),
  parameters: z.unknown(),
  progress: z.unknown(),
  checkpoint: z.unknown(),
  report: z.unknown().nullable(),
  errorMessage: z.string().nullable(),
  durationMs: z.number().nullable(),
  initiatedAt: z.coerce.date(),
  completedAt: z.coerce.date().nullable(),
  saasProduct: z.object({
    id: z.string().uuid(),
    name: z.string(),
    slug: z.string(),
  }),
});

const listSchema = z.object({ items: z.array(runSchema) });

export type BootstrapRun = z.output<typeof runSchema>;

export async function startBootstrap(body: {
  saas_product_id: string;
  api_url: string;
  api_key: string;
  history_window: '12m' | '24m' | 'all';
  is_dry_run: boolean;
}): Promise<{ runId: string }> {
  const res = await apiClient.post<{ data: { runId: string } }>(
    '/api/integration/bootstrap-runs',
    body,
  );
  return res.data.data;
}

export async function fetchBootstrapRuns(saasProductId?: string): Promise<BootstrapRun[]> {
  const qs = saasProductId ? `?saas_product_id=${saasProductId}` : '';
  const res = await apiClient.get<unknown>(`/api/integration/bootstrap-runs${qs}`);
  return listSchema.parse(res.data).items;
}

export async function fetchBootstrapRun(id: string): Promise<BootstrapRun> {
  const res = await apiClient.get<unknown>(`/api/integration/bootstrap-runs/${id}`);
  return runSchema.parse(res.data);
}
